module.exports = __webpack_public_path__ + "590021d0e923ab3a5c97207076ccc4ef.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/wave-left-18.png
// module id = 2663
// module chunks = 0